import axios from "axios";
import tags from "../../models/etiquetas/tags";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getTags() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/etiquetas`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return tags.fromJson(item);
      });
    });
  }

  addTag(payload) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.post(`${url}/etiquetas`, payload, { headers }).then((data) => {
      return tags.fromJson(data.data);
    });
  }

  addTagsGroup(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .post(`${url}/reportes/etiquetas`, data, { headers })
      .then((data) => {
        return data.data;
      });
  }

  deleteTags(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/etiquetas/${id}`, { headers });
  }

  editTag(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {};

    if (data.hasOwnProperty("nombre")) {
      payload.nombre = data.nombre;
    }
    if (data.hasOwnProperty("descripcion")) {
      payload.descripcion = data.descripcion;
    }
    if (data.hasOwnProperty("color")) {
      payload.color = data.color;
    }

    return axios.patch(`${url}/etiquetas/${data.etiquetaId}`, payload, {
      headers,
    });
  }

  addTagsEmpGroup(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .post(`${url}/empleados/etiquetas`, data, { headers })
      .then((data) => {
        return data.data;
      });
  }

  getEmpTags(tagId) {
    let token = localStorage.getItem("token");
    const operId = parseInt(localStorage.getItem("operId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/empleados/etiquetas/${operId}&${tagId}`, { headers })
      .then(({ data }) => {
        return data;
      });
  }

  getOneEmpTags() {
    let token = localStorage.getItem("token");
    const empId = parseInt(localStorage.getItem("empId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/empleados/${empId}/etiquetas`, { headers })
      .then(({ data }) => {
        return data;
      });
  }

  deleteEmpTag(tagId) {
    let token = localStorage.getItem("token");
    const empId = parseInt(localStorage.getItem("empId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/empleados/etiquetas/${empId}&${tagId}`, {
      headers,
    });
  }
}
export default service;
